import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "di-loader",
	templateUrl: "./loader.component.html",
	styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit {
	@Input() size = 50;
	@Input() color = "CouleurPrimaire";
	@Input() loaderText = "Chargement...";
	public visible: boolean;

	constructor(private cdr: ChangeDetectorRef) { }

	public ngOnInit(): void { }

	open() {
		this.visible = true;
		this.cdr.detectChanges();
	}

	close() {
		this.loaderText = '';
		this.color = "CouleurPrimaire";
		this.visible = false;
		this.cdr.detectChanges();
	}
}
